const FgBlack = "\x1b[30m"
const FgRed = "\x1b[31m"
const FgGreen = "\x1b[32m"
const FgYellow = "\x1b[33m"
const FgBlue = "\x1b[34m"
const FgMagenta = "\x1b[35m"
const FgCyan = "\x1b[36m"
const FgWhite = "\x1b[37m"

module.exports = class Timer {
  constructor(name) {
    this.name = name;
    this.timerInterval = false;
    this.timerEndTimeout = false;
    this.timerContinueTime = 0;
    this.timeRemaining = 20000;
    this.timeElapse = 0;
    this.timerStartTime = 0;
    this.useRemaining = true;
    this.useTick = true;
    this.trace = false;
    this.subscribed = [];
    this.isStop = false;
    this.subscribedEnd = [];
  }
  subscribe(callback) {
    this.subscribed.push(callback)
  }
  subscribeEnd(callback) {
    this.subscribedEnd.push(callback)
  }
  timer() {
    return this;
  }
  setTrace(trace) {
    this.trace = trace
    return this;
  }
  setUseRemaining(useRemaining) {
    this.useRemaining = useRemaining
    return this;
  }
  setUseTick(useTick) {
    this.useTick = useTick
    return this;
  }
  addTimeRemaining(remainingTime) {
    if (remainingTime >= 0) {
      this.timeRemaining = this.timeRemaining + remainingTime;
    } else {
      console.log('Cannot Add Negative Time');
    }
    return this;
  }
  setTimeRemaining(remainingTime) {
    if (remainingTime >= 0) {
      this.timeRemaining = remainingTime;
    } else {
      console.log('Cannot Set Negative Time');
    }
    return this;
  }
  setTimeElapse(elapse) {
    this.timeElapse = elapse;
    return this;
  }
  setTimeElapseFrom(fromTime) {
    this.timeElapse = Date.now() - fromTime;
    return this;
  }
  setTimeStart(timerStartTime) {
    this.timerStartTime = timerStartTime;
    return this;
  }
  startFromAndRemaining(fromTime, timeElapse, remainingTime = 0) {
    if (!this.timerInterval && !this.timerEndTimeout) {
      this.timerStartTime = fromTime;
      this.timeElapse = timeElapse;
      if (remainingTime > 0) {
        this.timeRemaining = remainingTime;
      }
      this.start();
    } else {
      console.log('Cannot Continue, Already Running Timer');
    }
  }
  startFromAndEndTo(fromTime, timeElapse, endTime) {
    if (!this.timerInterval && !this.timerEndTimeout) {
      this.timerStartTime = fromTime;
      this.timeElapse = timeElapse;
      this.timeRemaining = endTime - Date.now();
      this.start();
    } else {
      console.log('Cannot Continue, Already Running Timer');
    }
  }
  resetEndTimeout() {
    clearTimeout(this.timerEndTimeout);
    this.timerEndTimeout = false;
    console.log('Reset End Timeout');
    console.log({
      this: this
    });
    if (this.useRemaining) {
      // This is for ending the timer when time remaining ends
      this.timerEndTimeout = setTimeout(() => {
        if (this.trace) {
          console.log('-------------------------', FgBlue);
          console.log('Ended', FgWhite);
          console.log('-------------------------');
        }
        this.stop();
        // this.subscribed.forEach((callback, i) => {
        //   callback(this.getTime())
        // });
        // this.subscribedEnd.forEach((callback, i) => {
        //   callback(this.getTime())
        // });
      }, this.timeRemaining)
    }

  }
  resetSetInterval() {
    clearInterval(this.timerInterval);
    this.timerInterval = false;
    if (this.useTick) {
      // This is just for showing the time
      // Do not place any important time logic here
      // You can place web push to subscriber here so users can view
      this.subscribed.forEach((callback, i) => {
        callback(this.getTime())
      });
      this.timerInterval = setInterval(() => {
        this.checkTimeCalculated('1 Second');
        this.subscribed.forEach((callback, i) => {
          callback(this.getTime())
        });
        const now = Date.now();
        const ownMillis = now - this.timerContinueTime;
        const timeRemaining = this.timeRemaining - ownMillis;
        if (this.useRemaining && timeRemaining < 0) {
          console.log('End from Timer Interval');
          this.stop();
          this.subscribedEnd.forEach((callback, i) => {
            callback(this.getTime())
          });
        }
      }, 1000);
    }

  }
  start() {
    // Logic for starting time
    if (!this.timerInterval && !this.timerEndTimeout) {
      const nowStart = Date.now();
      this.timerContinueTime = nowStart;
      if (this.timerStartTime <= 0) {
        this.timerStartTime = nowStart;
      }
      const ownMillisStart = nowStart - this.timerContinueTime;
      const timeRemainingStart = this.timeRemaining - ownMillisStart;
      this.checkTimeRaw('Start');
      this.resetSetInterval();
      this.resetEndTimeout();
      this.isStop = false;
      this.subscribed.forEach((callback, i) => {
        callback(this.getTime())
      });

    } else {
      console.log('Cannot Start, Already Running Timer');
    }
    return this;
  }
  startAddRemaining(remainingMillis) {
    this.timeRemaining = this.timeRemaining + remainingMillis;
    this.start();
    return this;
  }
  startSetRemaining(remainingMillis) {
    this.timeRemaining = remainingMillis;
    this.start();
    return this;
  }
  stop() {
    clearInterval(this.timerInterval);
    clearTimeout(this.timerEndTimeout);
    this.timerInterval = false;
    this.timerEndTimeout = false;
    const now = Date.now();
    const ownMillis = now - this.timerContinueTime;
    this.timeRemaining = this.timeRemaining - ownMillis;
    this.timeElapse = this.timeElapse + ownMillis;
    this.checkTimeRaw('Stop');
    this.isStop = true;
    this.subscribed.forEach((callback, i) => {
      callback(this.getTime())
    });
    return this;
  }
  stopWithTime(timeElapse, timeRemaining) {
    clearInterval(this.timerInterval);
    clearTimeout(this.timerEndTimeout);
    this.timerInterval = false;
    this.timerEndTimeout = false;
    this.timeElapse = timeElapse;
    this.timeRemaining = timeRemaining;
    this.isStop = true;
    this.subscribed.forEach((callback, i) => {
      callback(this.getTime())
    });
    return this;
  }
  update(timeElapse) {
    this.timeElapse = timeElapse;
    this.subscribed.forEach((callback, i) => {
      callback(this.getTime())
    });
    return this;
  }
  checkTimeCalculated(title = "Check Time Calculated") {
    let color = FgYellow;

    const now = Date.now();
    const ownMillis = now - this.timerContinueTime;
    const timeRemaining = this.timeRemaining - ownMillis;
    const timeElapse = this.isStop ? this.timeElapse : this.timeElapse + ownMillis;
    const dateCurrent = new Date();
    const dateStartedTotal = new Date(this.timerStartTime);
    const dateSession = new Date(this.timerContinueTime);
    const dateEnd = new Date(now + timeRemaining);
    const timeStart = `${dateStartedTotal.getHours()}:${dateStartedTotal.getMinutes()}:${dateStartedTotal.getSeconds()}`;
    const timeSession = `${dateSession.getHours()}:${dateSession.getMinutes()}:${dateSession.getSeconds()}`;
    const timeNow = `${dateCurrent.getHours()}:${dateCurrent.getMinutes()}:${dateCurrent.getSeconds()}`;
    let timeEnd = `${dateEnd.getHours()}:${dateEnd.getMinutes()}:${dateEnd.getSeconds()}`;

    if (this.trace) {
      console.log('-------------------------', color);
      console.log(title, FgWhite, "\x1b[40m");
      console.log(`elapsed session = ${Math.floor(ownMillis / 1000)}s ${Math.floor(ownMillis)}ms`);
      console.log(`elapsed from start = ${Math.floor(timeElapse / 1000)}s ${Math.floor(timeElapse)}ms`);
      if (this.useRemaining) console.log(`time remaining = ${Math.floor(timeRemaining / 1000)}s ${Math.floor(timeRemaining)}ms`);
      console.log(`time = start(${timeStart}), session(${timeSession}), now(${timeNow}), end(${this.useRemaining ? timeEnd : 'No end'})`)
      console.log('-------------------------');
    }
  }
  checkTimeRaw(title = "Check Time Raw") {
    let color = FgWhite;
    if (title === "Stop") color = FgRed;
    if (title === "Start") color = FgGreen;

    const now = Date.now();
    const ownMillis = now - this.timerContinueTime;
    if (this.trace) {
      console.log('-------------------------', color);
      console.log(title, FgWhite);
      console.log(`elapsed session = ${Math.floor(ownMillis / 1000)}s ${Math.floor(ownMillis)}ms`);
      console.log(`elapsed from start = ${Math.floor(this.timeElapse / 1000)}s ${Math.floor(this.timeElapse)}ms`);
      if (this.useRemaining) console.log(`time remaining = ${Math.floor(this.timeRemaining / 1000)}s ${Math.floor(this.timeRemaining)}ms`);
      console.log('-------------------------');
    }
  }
  check() {
    if (this.trace) {
      console.log('-------------------------');
      console.log('Check');
      console.log({
        TimeInterval: this.timerInterval,
        TimeEndTimeout: this.timerEndTimeout,
      });
      console.log('-------------------------');
    }
  }
  getTime() {
    const now = Date.now();
    const ownMillis = now - this.timerContinueTime;
    const timeRemaining = this.timeRemaining - ownMillis;
    const timeElapse = this.isStop ? this.timeElapse : this.timeElapse + ownMillis;

    const dateCurrent = new Date();
    const dateStartedTotal = new Date(this.timerStartTime);
    const dateSession = new Date(this.timerContinueTime);
    const dateEnd = new Date(now + timeRemaining);
    const timeStart = `${dateStartedTotal.getHours()}:${dateStartedTotal.getMinutes()}:${dateStartedTotal.getSeconds()}`;
    const timeSession = `${dateSession.getHours()}:${dateSession.getMinutes()}:${dateSession.getSeconds()}`;
    const timeNow = `${dateCurrent.getHours()}:${dateCurrent.getMinutes()}:${dateCurrent.getSeconds()}`;
    let timeEnd = `${dateEnd.getHours()}:${dateEnd.getMinutes()}:${dateEnd.getSeconds()}`;

    return {
      timeStart: dateStartedTotal.getTime(),
      timeSession: dateSession.getTime(),
      timeNow: now,
      timeEnd: dateEnd.getTime(),
      formattedTimeStart: timeStart,
      formattedTimeSession: timeSession,
      formattedTimeNow: timeNow,
      formattedTimeEnd: timeEnd,
      timeSinceSessionStart: ownMillis,
      timeRemaining,
      timeElapse,
      stopped: this.isStop
    }
  }
}
